import { useRef, useEffect, useState } from "react";
import { Screens, SelectedPage, Color, Competence } from "../../shared/types";
import useMediaQuery from "../../hooks/useMediaQuery";
import { NavLink, useLocation } from "react-router-dom";
import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Sliding1 from "../../assets/sliding_1.png";
import Sliding2 from "../../assets/sliding_2.png";
import Sliding3 from "../../assets/sliding_3.png";

import Mechanical from "../../assets/mechanical.png";
import Consultancy from "../../assets/consultancy.png";
import Simulation from "../../assets/simulation.png";
import LatestNewsSection from "./components/news";
import AboutPage from "./components/about";
import ProjectsPage from "./components/projectsPage";
import ContactUs from "./components/contacts";
import Footer from "../../Components/Footer";
import { animated, useSpring } from "react-spring";

import { Link, Element, Events, scrollSpy } from "react-scroll";
import competencesData from "../Competences/populateCompetences";

type Props = {
  buttonHover: boolean;
  setButtonHover: (value: boolean) => void;
  isMenuToggled: boolean;
  setIsMenuToggled: (value: boolean) => void;
  selectedDiv: String;
  setSelectedDiv: (value: String) => void;
  previousDiv: String;
  setPreviousDiv: (value: String) => void;
  setSelectedPage(value: SelectedPage): void;
  setCompetence: (value: Competence) => void;
};

function HomePage({
  buttonHover,
  setButtonHover,
  isMenuToggled,
  setIsMenuToggled,
  selectedDiv,
  setSelectedDiv,
  previousDiv,
  setPreviousDiv,
  setSelectedPage,
  setCompetence,
}: Props) {
  const aboutRef = useRef<HTMLDivElement>(null);
  const isAboveSmallScreens = useMediaQuery(Screens.Small);

  const scrollToAbout = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const ref = useRef<HTMLDivElement>(null);

  const scrollToRef = () => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getMurWidth = (): string =>
    isAboveSmallScreens ? "w-24 h-24" : "w-16 h-16";

  const getWritesWidth = (): string => (isAboveSmallScreens ? "w-44" : "w-24");

  const carouselImages = [Sliding1, Sliding2, Sliding3];

  const settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
  };

  const isAboveHugeScreen = useMediaQuery(Screens.Huge);
  const isAboveLargeScreen = useMediaQuery(Screens.Large);
  const isAboveMediumScreen = useMediaQuery(Screens.Medium);

  const history = useLocation();

  useEffect(() => {
    setSelectedPage(SelectedPage.Home);
  }, [history]);

  function getHeight(): String {
    if (isAboveHugeScreen) {
      return " mt-whiteSpacingXL";
    } else if (isAboveLargeScreen) {
      return "mt-whiteSpacingM";
    } else if (isAboveMediumScreen || isAboveSmallScreens) {
      return "mt-whiteSpacingS";
    } else {
      return "mt-whiteSpacingSL";
    }
  }

  const fade = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 1500 }, // Durata dell'animazione in millisecondi (esempio: 1000ms = 1 secondo)
  });

  useEffect(() => {
    // Configure react-scroll
    Events.scrollEvent.register("begin", function () {
      console.log("begin", arguments);
    });

    Events.scrollEvent.register("end", function () {
      console.log("end", arguments);
    });

    scrollSpy.update();

    return () => {
      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
    };
  }, []);

  return (
    <main className={`flex-1 overflow-y-auto h-full mt-16 sm:mt-0 `}>
      <div id="HomePage" className="overflow-x-hidden h-full">
        <Slider {...settings}>
          {carouselImages.map((imageUrl, index) => (
            <div key={index} className="relative">
              <img
                src={imageUrl}
                alt={`carousel-image-${index}`}
                className="w-full h-[calc(200px)] sm:h-[calc(400px)] 2xl:h-[calc(700px)] object-cover "
              />
            </div>
          ))}
        </Slider>
        <div className="text-center mt-8 2xl:mt-16 text-3xl sm:text-5xl 2xl:text-7xl font-light sm:mx-0 mx-4 text-palette1 stylish-title">
          How to <span className="text-palette3">Dream Innovation </span> in the
          Future
        </div>{" "}
        <animated.div style={fade}>
          <div className="grid grid-cols-1 2xl:mt-16 items- sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8 mt-8 pt-4 pb-8 px-16">
            {competencesData.map((competence) => (
              <NavLink
                to={`/competence`}
                onClick={() => {
                  setSelectedPage(SelectedPage.Competences);
                  setCompetence(competence);
                }}
              >
                <div
                  key={competence.id}
                  className="bg-white p-6 h-full rounded-md shadow-lg transition duration-300 transform hover:-translate-y-2 hover:shadow-xl cursor-pointer"
                >
                  <div
                    className={`flex justify-center mb-4 text-4xl ${competence.color}`}
                  >
                    {competence.icon}
                  </div>
                  <h2 className="text-xl text-center font-bold mb-2">
                    {competence.title}
                  </h2>
                  <p className="text-gray-950 text-center">
                    {competence.shortDescription}
                  </p>
                </div>
              </NavLink>
            ))}
          </div>
        </animated.div>
        <LatestNewsSection setSelectedPage={setSelectedPage} />
        <AboutPage setSelectedPage={setSelectedPage} />
        <ProjectsPage setSelectedPage={setSelectedPage} />
        <ContactUs />
      </div>
    </main>
  );
}

export default HomePage;
